import Helper from '@ember/component/helper';

export default class FormatLatLongHelper extends Helper {
  compute([latitude, longitude]: [string | number, string | number]) {
    if (latitude === undefined || latitude === null) {
      throw new Error('Latitude must be provided');
    }

    if (longitude === undefined || latitude === null) {
      throw new Error('Longitude must be provided');
    }

    return `${latitude}, ${longitude}`;
  }
}
